import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'a-center-container-scrollable',
  templateUrl: './a-center-container-scrollable.component.html',
  styleUrls: ['./a-center-container-scrollable.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ACenterContainerScrollableComponent {}
